import React, { ChangeEventHandler } from 'react'
import { MoneyInput as AmountInput } from '@/modules/drivers/tabs/registry/views/payroll/components/MoneyInput'
import { Dropdown } from './Dropdown'
import { CurrencyModel } from '@/app/models/newDelegation/currencyModel'
import clx from 'classnames'
import { useBusinessTripRatesTableContext } from '../context/BusinessTripRatesTableContext'
import { useBusinessTripRatesRowContext } from '../context/BusinessTripRatesRowContext'

type Props = {
  value: number
  currency: CurrencyModel
  name: string
  currencyName: string
  availableCurrencies: CurrencyModel[]
  isDirty?: boolean
  handleValueChange: ChangeEventHandler<HTMLInputElement>
  handleCurrencyChange: (fieldName: string, code: string) => void
}

export const MoneyInput = (props: Props) => {
  const {
    value,
    currency,
    name,
    currencyName,
    availableCurrencies = [],
    handleCurrencyChange,
    handleValueChange,
  } = props
  const {
    // rates,
    savedRates,
    // availableCountries,
    // availableCurrencies,
    // handleUpdate,
    // handleDelete,
  } = useBusinessTripRatesTableContext()
  const { rate } = useBusinessTripRatesRowContext()
  const saved = savedRates.find((sr) => sr.id === rate.id)
  const isDirty = !saved || Boolean(
    Boolean(saved[name] !== rate[name]) ||
      Boolean(saved[currencyName] !== rate[currencyName]),
  )

  return (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-2">
      <AmountInput
        value={value}
        name={name}
        isDirty={isDirty}
        onChange={handleValueChange}
        // onBlur={() => {}}
        className="tw-w-full tw-bg-transparent tw-px-1 tw-text-right focus:tw-outline-none" //focus-within:tw-text-left
      />
      <Dropdown
        portalPosition="to-right"
        options={availableCurrencies.map((c) => ({
          label: `${c.code} ${c.name}`,
          value: c.code,
        }))}
        value={currency?.code}
        // name={currencyName}
        onChange={(code) => handleCurrencyChange(currencyName, code)}
        className="tw-text-right"
      >
        <span className={clx(isDirty ? 'tw-text-red-400' : '')}>
          {currency?.code || '---'}
        </span>
      </Dropdown>
    </div>
  )
}
